<template>
  <div class="legal-page">
    <div class="container">
      <div class="card">
        <h1 class="card-header">{{ $t('legal.termsTitle') }}</h1>
        <div class="card-content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import terms from './terms.content.js'

export default {
  name: 'terms',
  computed: {
    ...mapGetters(['language']),
    content () {
      return terms[this.language] || terms['zh-tw']
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/views/Legal.scss';
</style>
